import { useState, useEffect, useMemo, useRef } from "react";

import "../css/CashPopup.css";

import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import InputData from "../../components/InputData";
import InputTextArea from "../../components/InputTextArea";
import LoadingScreen from "../../components/LoadingScreen";

import DataTable from "react-data-table-component";
import moment from "moment";

import { formatCurrency } from "../utils/utils";
import { post, download } from "../../js/post";
import { post as rpost } from "../js/api";
import { userData, selectedOptic } from "../../js/utils";
import { monthNumberToName } from "../utils/utils";

export default ({
  opticaId,
  fechaInicio,
  fechaFin,
  tipo,
  show,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [dateFrom, setDateFrom] = useState(
    fechaInicio ? fechaInicio : moment().format("YYYY-MM-DD"),
  );
  const [dateTo, setDateTo] = useState(
    fechaFin ? fechaFin : moment().format("YYYY-MM-DD"),
  );

  const [optics, setOptics] = useState([]);
  const [selOptic, setSelOptic] = useState(null);

  const [paymentsTable, setPaymentsTable] = useState([]);
  const [returnsTable, setReturnsTable] = useState([]);
  const [movementsTable, setMovementsTable] = useState([]);
  const [resultsTable, setResultsTable] = useState([]);

  const [totalPayments, setTotalPayments] = useState(0);
  const [totalReturns, setTotalReturns] = useState(0);
  const [totalIncomes, setTotalIncomes] = useState(0);
  const [totalOutcomes, setTotalOutcomes] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [totalTotal, setTotalTotal] = useState(0);

  const [movementPopup, setMovementPopup] = useState(null);

  const [paymentMethods, setPaymentMethods] = useState([]);

  const [loading, setLoading] = useState(true);
  // true en cuanto hay datos cargados: a partir de ahí, al recargar se
  // mantiene el contenido para que el popup no cambie de tamaño.
  const [loadedData, setLoadedData] = useState(false);
  // Identificador de la última carga lanzada, para descartar respuestas viejas.
  const loadRequestRef = useRef(0);
  const [loadedScreen, setLoadedScreen] = useState(false);

  const paymentsRef = useRef(null);
  const returnsRef = useRef(null);
  const movementsRef = useRef(null);
  const hiddenCalendarRef = useRef(null);

  const paymentsColumns = useMemo(
    () => [
      {
        name: "Factura",
        selector: (row) => row.invoice.toUpperCase(),
        sortable: true,
        width: "14%",
      },
      {
        name: "Fecha",
        selector: (row) =>
          moment(row.dateTime, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm"),
        sortable: true,
        sortFunction: (a, b) => a.dateTime.localeCompare(b.dateTime),
        width: "20%",
      },
      {
        name: "Agente",
        selector: (row) => row.agent.toUpperCase(),
        sortable: true,
        width: "32%",
      },
      {
        name: "Forma de pago",
        selector: (row) => row.paymentMethod.toUpperCase(),
        sortable: true,
        width: "20%",
      },
      {
        name: "Abono",
        selector: (row) => formatCurrency(row.price),
        sortable: true,
        width: "14%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(rowA.price) || 0;
          const valueB = parseFloat(rowB.price) || 0;
          return valueA - valueB;
        },
      },
    ],
    [paymentsTable],
  );

  const returnsColumns = useMemo(
    () => [
      {
        name: "Factura",
        selector: (row) => row.invoice.toUpperCase(),
        sortable: true,
        width: "14%",
      },
      {
        name: "Fecha",
        selector: (row) =>
          moment(row.dateTime, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm"),
        sortable: true,
        sortFunction: (a, b) => a.dateTime.localeCompare(b.dateTime),
        width: "20%",
      },
      {
        name: "Agente",
        selector: (row) => row.agent.toUpperCase(),
        sortable: true,
        width: "32%",
      },
      {
        name: "Forma de pago",
        selector: (row) => row.paymentMethod.toUpperCase(),
        sortable: true,
        width: "20%",
      },
      {
        name: "Abono",
        selector: (row) => formatCurrency(row.price),
        sortable: true,
        width: "14%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(rowA.price) || 0;
          const valueB = parseFloat(rowB.price) || 0;
          return valueA - valueB;
        },
      },
    ],
    [returnsTable],
  );

  const movementsColumns = useMemo(
    () => [
      {
        name: "Tipo",
        selector: (row) => row.type.toUpperCase(),
        sortable: true,
        width: "14%",
      },
      {
        name: "Fecha",
        selector: (row) =>
          moment(row.dateTime, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm"),
        sortable: true,
        sortFunction: (a, b) => a.dateTime.localeCompare(b.dateTime),
        width: "20%",
      },
      {
        name: "Descripción",
        selector: (row) => row.description.toUpperCase(),
        sortable: true,
        width: "32%",
      },
      {
        name: "Forma de pago",
        selector: (row) => row.paymentMethod.toUpperCase(),
        sortable: true,
        width: "20%",
      },
      {
        name: "Importe",
        selector: (row) => formatCurrency(row.price),
        sortable: true,
        width: "14%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(rowA.price) || 0;
          const valueB = parseFloat(rowB.price) || 0;
          return valueA - valueB;
        },
      },
    ],
    [movementsTable],
  );

  const resultsColumns = useMemo(
    () => [
      {
        name: "Forma de pago",
        selector: (row) => row.paymentMethod.toUpperCase(),
        sortable: true,
        width: "16%",
      },
      {
        name: "Abonos",
        selector: (row) => formatCurrency(row.payments),
        sortable: true,
        width: "16.8%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(rowA.payments) || 0;
          const valueB = parseFloat(rowB.payments) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Devoluciones",
        selector: (row) => formatCurrency(-row.returns),
        sortable: true,
        width: "16.8%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(-rowA.returns) || 0;
          const valueB = parseFloat(-rowB.returns) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Entradas",
        selector: (row) => formatCurrency(row.incomes),
        sortable: true,
        width: "16.8%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(rowA.incomes) || 0;
          const valueB = parseFloat(rowB.incomes) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Salidas",
        selector: (row) => formatCurrency(-row.outcomes),
        sortable: true,
        width: "16.8%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(-rowA.outcomes) || 0;
          const valueB = parseFloat(-rowB.outcomes) || 0;
          return valueA - valueB;
        },
      },
      {
        name: "Total abonos",
        selector: (row) => formatCurrency(row.total),
        sortable: true,
        width: "16.8%",
        right: true,
        sortFunction: (rowA, rowB) => {
          const valueA = parseFloat(rowA.total) || 0;
          const valueB = parseFloat(rowB.total) || 0;
          return valueA - valueB;
        },
      },
    ],
    [resultsTable],
  );

  const loadOptics = async () => {
    let opticsN = await post("ListarOpticas.php", {
      token: userData.token,
    });
    opticsN = opticsN.map((optic) => ({
      id: optic.id,
      text: optic.nombre,
    }));
    opticsN.unshift({
      id: -1,
      text: "TODAS",
    });
    setOptics(opticsN);
    const optic = opticsN.find((item) => item.id === opticaId);
    setSelOptic(optic ? optic : opticsN[0]);
  };

  const loadPaymentMethods = async () => {
    const response = await post("ListarFormasPago.php", {
      token: userData.token,
    });
    // El vale de caja no es una forma de pago válida para meter/sacar dinero.
    const paymentMethodsN = response
      .filter(
        (item) =>
          String(item.descripcion ?? "")
            .trim()
            .toUpperCase() !== "VALE DE CAJA",
      )
      .map((item) => {
        return {
          id: item.id,
          text: item.descripcion,
        };
      });
    setPaymentMethods(paymentMethodsN);
  };

  const onChangeOptic = (e) => {
    setSelOptic(e);
  };

  const onChangeDateFrom = (e) => {
    let date1 = e.target.value;
    let date2 = dateTo;
    if (date1 > date2) {
      date2 = date1;
    }
    setDateFrom(date1);
    setDateTo(date2);
  };

  const onChangeDateTo = (e) => {
    let date1 = dateFrom;
    let date2 = e.target.value;
    if (date1 > date2) {
      date1 = date2;
    }
    setDateFrom(date1);
    setDateTo(date2);
  };

  const onChangePaymentMethod = (e) => {
    const movementPopupN = structuredClone(movementPopup);
    movementPopupN.paymentMethod = e;
    setMovementPopup(movementPopupN);
  };

  const onChangePrice = (e) => {
    const movementPopupN = structuredClone(movementPopup);
    movementPopupN.price = e;
    setMovementPopup(movementPopupN);
  };

  const onChangeDescription = (e) => {
    const movementPopupN = structuredClone(movementPopup);
    movementPopupN.description = e;
    setMovementPopup(movementPopupN);
  };

  const createResultsTable = (payments, returns, movements) => {
    const grouped = {};

    payments.forEach((payment) => {
      const method = payment.paymentMethod;
      if (!grouped[method]) {
        grouped[method] = {
          paymentMethod: method,
          payments: 0,
          returns: 0,
          incomes: 0,
          outcomes: 0,
          salesTotal: 0,
          total: 0,
        };
      }
      grouped[method].payments += payment.price;
      grouped[method].salesTotal += payment.saleTotal;
    });

    returns.forEach((returnItem) => {
      const method = returnItem.paymentMethod;
      if (!grouped[method]) {
        grouped[method] = {
          paymentMethod: method,
          payments: 0,
          returns: 0,
          incomes: 0,
          outcomes: 0,
          salesTotal: 0,
          total: 0,
        };
      }
      grouped[method].returns += Math.abs(returnItem.price);
    });

    movements.forEach((movement) => {
      const method = movement.paymentMethod;
      if (!grouped[method]) {
        grouped[method] = {
          paymentMethod: method,
          payments: 0,
          returns: 0,
          incomes: 0,
          outcomes: 0,
          salesTotal: 0,
          total: 0,
        };
      }

      if (movement.type === "ENTRADA") {
        grouped[method].incomes += movement.price;
      } else if (movement.type === "SALIDA") {
        grouped[method].outcomes += Math.abs(movement.price);
      }
    });

    // Calcular totales para cada método de pago
    Object.keys(grouped).forEach((method) => {
      const group = grouped[method];
      group.total =
        group.payments - group.returns + group.incomes - group.outcomes;
    });

    const resultsTable = Object.values(grouped);

    // Calcular totales generales
    const totals = {
      totalPayments: 0,
      totalReturns: 0,
      totalIncomes: 0,
      totalOutcomes: 0,
      totalSales: 0,
    };

    resultsTable.forEach((row) => {
      totals.totalPayments += row.payments;
      totals.totalReturns += row.returns;
      totals.totalIncomes += row.incomes;
      totals.totalOutcomes += row.outcomes;
      totals.totalSales += row.salesTotal;
    });

    totals.totals =
      totals.totalPayments -
      totals.totalReturns +
      totals.totalIncomes -
      totals.totalOutcomes;

    return {
      resultsTable,
      totals,
    };
  };

  const loadPayments = async () => {
    const requestId = ++loadRequestRef.current;
    setLoading(true);

    const response = await rpost("ventas/ObtenerCajaDetallada.php", {
      token: userData.token,
      idOptica: selOptic.id,
      fechaInicio: dateFrom,
      fechaFin: dateTo,
    });

    if (requestId !== loadRequestRef.current) return;

    // Ordenadas por fecha, de la más antigua a la más reciente.
    const byDate = (list) =>
      [...(list ?? [])].sort((a, b) =>
        String(a.fecha).localeCompare(String(b.fecha)),
      );

    const paymentsN = byDate(response.abonos).map((item, index) => {
      return {
        id: index,
        invoice: item.serieFactura + item.numFactura,
        dateTime: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD HH:mm",
        ),
        agent: item.agente,
        paymentMethod: item.formaPago,
        price: item.abono,
        saleTotal: parseFloat(item.totalVenta) || 0,
      };
    });

    const returnsN = byDate(response.devoluciones).map((item, index) => {
      return {
        id: index,
        invoice: item.serieFactura + item.numFactura,
        dateTime: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD HH:mm",
        ),
        agent: item.agente,
        paymentMethod: item.formaPago,
        price: item.abono,
      };
    });

    const movementsN = byDate(response.movimientos).map((item, index) => {
      return {
        id: index,
        type: item.tipo,
        dateTime: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD HH:mm",
        ),
        description: item.descripcion,
        paymentMethod: item.formaPago,
        price: item.importe,
      };
    });

    setPaymentsTable(paymentsN);
    setReturnsTable(returnsN);
    setMovementsTable(movementsN);
    const { resultsTable, totals } = createResultsTable(
      paymentsN,
      returnsN,
      movementsN,
    );
    setResultsTable(resultsTable);
    setTotalPayments(totals.totalPayments);
    setTotalReturns(totals.totalReturns);
    setTotalIncomes(totals.totalIncomes);
    setTotalOutcomes(totals.totalOutcomes);
    setTotalSales(totals.totalSales);
    setTotalTotal(totals.totals);

    setLoadedData(true);
    setLoading(false);
  };

  const insertExtract = async () => {
    if (
      movementPopup.price.trim() === "" ||
      movementPopup.description.trim() === ""
    ) {
      createPopupQuestion(
        "Debe rellenar todos los campos del formulario.",
        removePopupQuestion,
        null,
        "Cerrar",
      );

      return;
    }

    if (parseInt(movementPopup.price) <= 0) {
      createPopupQuestion(
        "El importe debe ser mayor que cero.",
        removePopupQuestion,
        null,
        "Cerrar",
      );

      return;
    }

    const response = await rpost("ventas/MeterSacarCaja.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      abono:
        movementPopup.type === "insertion"
          ? movementPopup.price
          : -movementPopup.price,
      empleado: userData.id,
      formaPago: movementPopup.paymentMethod.text,
      descripcion: movementPopup.description,
    });

    const movement = {
      id: response.idMovimiento,
      type: movementPopup.type === "insertion" ? "ENTRADA" : "SALIDA",
      dateTime: moment().format("YYYY-MM-DD HH:mm"),
      description: movementPopup.description,
      paymentMethod: movementPopup.paymentMethod.text,
      price: parseInt(movementPopup.price),
    };
    const movementsN = structuredClone(movementsTable);
    movementsN.unshift(movement);
    setMovementsTable(movementsN);
    const { resultsTable, totals } = createResultsTable(
      paymentsTable,
      returnsTable,
      movementsN,
    );
    setResultsTable(resultsTable);
    setTotalPayments(totals.totalPayments);
    setTotalReturns(totals.totalReturns);
    setTotalIncomes(totals.totalIncomes);
    setTotalOutcomes(totals.totalOutcomes);
    setTotalSales(totals.totalSales);
    setTotalTotal(totals.totals);

    openMovementPopup(false);
    const today = moment().format("YYYY-MM-DD");
    setDateFrom(today);
    setDateTo(today);
  };

  const printReport = async (datos2) => {
    await download("support-extra/dashboard/ExportacionVentas.php", {
      token: userData.token,
      idOpticaEmail: "",
      opticas: [selectedOptic.id],
      agentes: [],
      campana: "",
      fechaDesde: dateFrom,
      fechaHasta: dateFrom,
      tipoInforme: 2,
      datos0: [],
      datos1: {
        empresa: "",
        ejercicio: "",
        opcion: 0,
      },
      datos2,
      tipoFichero: 0,
      email: "",
    }, { abrirEnPestana: true });
  };

  const onClickHeaderButton = (id) => {
    let targetRef = null;
    switch (id) {
      case "payments":
        targetRef = paymentsRef;
        break;
      case "returns":
        targetRef = returnsRef;
        break;
      case "movements":
        targetRef = movementsRef;
        break;
    }
    if (targetRef) {
      targetRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const openMovementPopup = async (show, type) => {
    if (show) {
      const movementPopupN = {
        price: "",
        description: "",
        paymentMethod: paymentMethods[0],
        type,
      };
      setMovementPopup(movementPopupN);
      setTimeout(() => {
        document.getElementById("cashpopup-importe")?.focus();
      }, 100);
    } else {
      setMovementPopup(null);
    }
  };

  const onClickOnSimpleDate = (e) => {
    e.stopPropagation();
    hiddenCalendarRef.current?.showPicker();
  };

  const onChangeDateFromHiddenCalendar = (e) => {
    setDateFrom(e.target.value);
    setDateTo(e.target.value);
  };

  const onClickPreviousArrow = () => {
    if (!loading) {
      const newDate = moment(dateFrom).subtract(1, "days").format("YYYY-MM-DD");
      setDateFrom(newDate);
      setDateTo(newDate);
    }
  };

  const onClickNextArrow = () => {
    if (!loading) {
      const newDate = moment(dateFrom).add(1, "days").format("YYYY-MM-DD");
      setDateFrom(newDate);
      setDateTo(newDate);
    }
  };

  const loadScreen = async () => {
    await Promise.all([loadOptics(), loadPaymentMethods()]);
    setLoadedScreen(true);
  };

  useEffect(() => {
    loadScreen();
  }, []);

  useEffect(() => {
    if (loadedScreen && show) {
      if (opticaId) {
        const optic = optics.find((item) => item.id === opticaId);
        setSelOptic(optic ? optic : optics[0]);
      }
      if (fechaInicio) {
        setDateFrom(fechaInicio);
      }
      if (fechaFin) {
        setDateTo(fechaFin);
      }
    }
  }, [show, opticaId, fechaInicio, fechaFin]);

  useEffect(() => {
    if (loadedScreen && selOptic && dateFrom !== "" && dateTo !== "") {
      loadPayments();
    }
  }, [loadedScreen, selOptic, dateFrom, dateTo]);

  return (
    show && (
      <div className="popup-container popup-normal popup-cash">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">
              {tipo === "detallado"
                ? "Cierre de caja detallada"
                : tipo === "estandar"
                  ? "Cierre de caja estándar"
                  : "Detalle de caja"}
            </div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={() => onClose()}
            />
          </div>
          <div className="popup-body">
            {tipo !== "movimientos" && (
              <div className="popup-row popup-cash-filters">
                <div className="label">Óptica</div>
                <Dropdown
                  tabIndex={10001}
                  id="cash-optics"
                  optionList={optics}
                  size={2}
                  op={selOptic ? selOptic.id : null}
                  onChange={onChangeOptic}
                  mandatory={true}
                />
                <div className="label">Fecha desde</div>
                <input
                  type="date"
                  tabIndex={10002}
                  className="input-field"
                  value={dateFrom}
                  onChange={onChangeDateFrom}
                  onKeyUp={null}
                />
                <div className="label">Fecha hasta</div>
                <input
                  type="date"
                  tabIndex={10003}
                  className="input-field"
                  value={dateTo}
                  onChange={onChangeDateTo}
                  onKeyUp={null}
                />
              </div>
            )}
            {tipo === "movimientos" && (
              <div className="popup-row popup-cash-filters popup-cash-filters-movements">
                <div
                  className="calendar-calendar-footer-info calendarArrow"
                  onClick={onClickPreviousArrow}
                >
                  &lt;
                </div>
                <div className="label">
                  <span onClick={onClickOnSimpleDate}>
                    {moment(dateFrom).format("DD") +
                      " " +
                      monthNumberToName(moment(dateFrom).format("MM")) +
                      " " +
                      moment(dateFrom).format("YYYY")}
                  </span>
                  <input
                    className="hidden-calendar"
                    ref={hiddenCalendarRef}
                    type="date"
                    onChange={onChangeDateFromHiddenCalendar}
                    value={dateFrom}
                  />
                </div>
                <div
                  className="calendar-calendar-footer-info calendarArrow"
                  onClick={onClickNextArrow}
                >
                  &gt;
                </div>
              </div>
            )}
            {tipo !== "estandar" && (
              <div className="popup-cash detailed-view-header">
                <button
                  className="optometry-icon-header-icon"
                  disabled={false}
                  onClick={() => onClickHeaderButton("payments")}
                >
                  <img
                    src="/images/support-extra/caja-in.svg"
                    loading="lazy"
                    alt="Icon"
                  />
                  <span>Abonos ({paymentsTable.length})</span>
                </button>
                <button
                  className="optometry-icon-header-icon"
                  disabled={false}
                  onClick={() => onClickHeaderButton("returns")}
                >
                  <img
                    src="/images/support-extra/caja-out.svg"
                    loading="lazy"
                    alt="Icon"
                  />
                  <span>Devoluciones ({returnsTable.length})</span>
                </button>
                <button
                  className="optometry-icon-header-icon"
                  disabled={false}
                  onClick={() => onClickHeaderButton("movements")}
                >
                  <img
                    src="/images/support-extra/caja-waves.svg"
                    loading="lazy"
                    alt="Icon"
                  />
                  <span>Movimientos ({movementsTable.length})</span>
                </button>
              </div>
            )}
            {!loadedData && (
              <LoadingScreen message="Cargando datos de caja..." />
            )}
            {loadedData && tipo !== "estandar" && (
              <div
                className={
                  "popup-cash detailed-view-body" +
                  (loading ? " popup-cash-reloading" : "")
                }
              >
                <div ref={paymentsRef} className="popup-row popup-row-bold">
                  Abonos
                </div>
                <div className="popup-row table-scrollable">
                  <DataTable
                    columns={paymentsColumns}
                    data={paymentsTable}
                    className="custom-datatable non-interactive"
                    noDataComponent="No hay datos disponibles."
                  />
                </div>
                <div ref={returnsRef} className="popup-row popup-row-bold">
                  Devoluciones
                </div>
                <div className="popup-row table-scrollable">
                  <DataTable
                    columns={returnsColumns}
                    data={returnsTable}
                    className="custom-datatable non-interactive"
                    noDataComponent="No hay datos disponibles."
                  />
                </div>
                <div ref={movementsRef} className="popup-row popup-row-bold">
                  Movimientos
                </div>
                <div className="popup-row table-scrollable">
                  <DataTable
                    columns={movementsColumns}
                    data={movementsTable}
                    className="custom-datatable non-interactive"
                    noDataComponent="No hay datos disponibles."
                  />
                </div>
              </div>
            )}
            {loadedData && (
              <div className="popup-row popup-row-bold popup-row-blue">
                Resultado de caja
              </div>
            )}
            {loadedData && (
              <div
                id="popup-cash-results"
                className={
                  "popup-row table-scrollable" +
                  (tipo === "estandar" ? " popup-cash-results-estandar" : "")
                }
              >
                <DataTable
                  columns={resultsColumns}
                  data={resultsTable}
                  className="custom-datatable non-interactive"
                  noDataComponent="No hay datos disponibles."
                />
                {resultsTable.length > 0 && (
                  <div className="popup-cash-summary-row">
                    <div />
                    <div>
                      <span>{formatCurrency(totalPayments)}</span>
                    </div>
                    <div>
                      <span>{formatCurrency(-totalReturns)}</span>
                    </div>
                    <div>
                      <span>{formatCurrency(totalIncomes)}</span>
                    </div>
                    <div>
                      <span>{formatCurrency(-totalOutcomes)}</span>
                    </div>
                    <div>
                      <span>{formatCurrency(totalTotal)}</span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="popup-cash-footer">
            {/* <ButtonIconH
              text="Introducir"
              onClick={() => openMovementPopup(true, "insertion")}
            />
            <ButtonIconH
              text="Extraer"
              onClick={() => openMovementPopup(true, "extraction")}
            /> */}
            <ButtonIconH
              text="Imprimir informe estándar"
              onClick={() => printReport(0)}
            />
            <ButtonIconH
              text="Imprimir informe detallado"
              onClick={() => printReport(1)}
            />
          </div>
        </div>
        {movementPopup && (
          <div className="popup-container popup-normal popup-cash-movement">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">
                  {movementPopup.type === "insertion"
                    ? "Inserción manual en caja"
                    : "Extracción manual de caja"}
                </div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={() => openMovementPopup(false)}
                />
              </div>
              <div className="popup-body">
                <div className="popup-row popup-row-price">
                  <div className="label">Importe (€)</div>
                  <InputData
                    id="cashpopup-importe"
                    tabIndex={20001}
                    type="type-float"
                    size={1}
                    input={movementPopup.price}
                    onChange={onChangePrice}
                  />
                </div>
                <div className="popup-row popup-row-top">
                  <div className="label">Motivo</div>
                  <InputTextArea
                    tabIndex={20002}
                    maxLength={400}
                    type="type-full"
                    size={3}
                    input={movementPopup.description}
                    onChange={onChangeDescription}
                  />
                </div>
                <div className="popup-row">
                  <div className="label">Forma de pago</div>
                  <Dropdown
                    tabIndex={20003}
                    id="cash-movement-payment-method"
                    disabled={false}
                    optionList={paymentMethods}
                    size={3}
                    op={movementPopup.paymentMethod.id}
                    onChange={onChangePaymentMethod}
                  />
                </div>
              </div>
              <div className="popup-cash-footer">
                <ButtonIconH
                  text={
                    movementPopup.type === "insertion" ? "Insertar" : "Extraer"
                  }
                  onClick={insertExtract}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};
